import FeatureGates from "@atlassian/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { SitesContextProvider } from "@/components/sites-provider";
import {
    JiraSoftwareFeaturesPageTemplate,
    JiraSoftwareFeaturesPageTemplateV2
} from "@/templates/jira-software-features-page/src";

export const JiraSoftwareFeaturesPage = () => {
    const showJiraSoftwareFeaturesV2 =
        FeatureGates.checkGate("wac-jira-features-team24-gate") ?? false;

    return (
        <SitesContextProvider>
            <SiteSelectorContextProvider
                analyticsPrefix="jsm.show"
                productKey={ProductKeys.JIRA_SOFTWARE}
            >
                {showJiraSoftwareFeaturesV2 ? (
                    <JiraSoftwareFeaturesPageTemplateV2 />
                ) : (
                    <JiraSoftwareFeaturesPageTemplate />
                )}
            </SiteSelectorContextProvider>
        </SitesContextProvider>
    );
};
